/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import {formatDateTime} from '@ion/core/src/utils/DateUtil';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';
import {GridItem} from './DeviceDetailsTab';

export interface ShippingWarrantyTabType {
  selectedTab: Number;
  tabIndex: Number;
  shippingInfo: GenericObject;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  formSection : {
    ...dlsAlt('typography', 'cta3'),
    fontWeight    : 700,
    color         : dlsColor('grey1'),
    letterSpacing : '0',
    padding       : '20px 0 10px 0'
  },
  leftContainer : {
    flex            : 1,
    backgroundColor : dlsColor('white'),
    marginRight     : '20px'
  },
  rightContainer : {
    flex            : 1,
    backgroundColor : dlsColor('white'),
    margin          : '0 10px'
  },
  field : {
    height : '296px'
  },
  gridItem : {
    borderBottom : `1px solid ${dlsColor('grey6')}`,
    height       : '74px',
    paddingTop   : '10px'
  },
  headerItem : {
    ...dlsAlt('typography', 'label1'),
    fontWeight : 700,
    color      : dlsColor('grey2'),
    fontSize   : '14px',
    padding    : '5px 20px'
  },
  bodyItem : {
    ...dlsAlt('typography', 'label2'),
    color      : dlsColor('grey2'),
    fontWeight : 400,
    padding    : '5px 20px 15px'
  },
  flexStyle : {
    display : 'flex'
  }
}));

/**
 * ShippingWarrantyTab component that displays the Device data
 * for the selected Device Details tab.
 */
export const ShippingWarrantyTab = ({
  shippingInfo,
  tabIndex = 0,
  selectedTab = 0
}: ShippingWarrantyTabType) => {
  const classes  = useStyles();

  return (
    <div id={`detailsTab_${tabIndex}`} hidden={selectedTab !== tabIndex}>
      <div className={classes.formSection}>{translate('admin-devices:view.shipping.title')}</div>
      <Grid container
        spacing={0}
        alignItems='flex-start'
        justifyContent='flex-start'>
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.shippingDate')}
          value={formatDateTime(shippingInfo?.ShipDate)} />
        {/* <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.carrier')}
          value={''} /> */}
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.carrierTracking')}
          value={shippingInfo?.ShipTracking} />
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.poNumber')}
          value={shippingInfo?.PurchaseOrder} />
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.customer')}
          value={shippingInfo?.ShipCustomer} />
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.assignedDate')}
          value={formatDateTime(shippingInfo?.AssignedDate)} />
        {/* <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.assignedTime')}
          value={''} /> */}
        <GridItem classes={classes}
          mdSpacing={3}
          label={translate('admin-devices:view.shipping.assignedBy')}
          value={shippingInfo?.AssignedBy?.replace(/\s/g, '')} />
      </Grid>
      {/* <div className={classes.formSection}>{translate('admin-devices:view.Warranty.title')}</div>
      <Grid container
        spacing={0}
        alignItems='flex-start'
        justifyContent='flex-start'>
        <GridItem classes={classes}
          mdSpacing={6}
          label={translate('admin-devices:view.Warranty.startDate')}
          value={''} />
        <GridItem classes={classes}
          mdSpacing={6}
          label={translate('admin-devices:view.Warranty.periodLeft')}
          value={''} />
      </Grid> */}
    </div>
  );
};

export default ShippingWarrantyTab;
